import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72fcd676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick", "disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]

import { ref, toRefs, unref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    disabled: { type: Boolean },
    skipConfirm: { type: Boolean },
    forceOnClick: null,
    customDisplay: null
  },
  emits: ["click", "confirmingChanged"],
  setup(__props: any, { emit }: { emit: ({
    (e: "click"): void;
    (e: "confirmingChanged", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const _props = __props as {
    disabled?: boolean;
    skipConfirm?: boolean;
    forceOnClick?: () => void;
    customDisplay?: string;
}


const props = toRefs(_props);


const isConfirming = ref(false);

watch(isConfirming, isConfirming => {
    emit("confirmingChanged", isConfirming);
});

function click() {
    if (unref(props.skipConfirm)) {
        emit("click");
        props?.forceOnClick?.value?.();
        return;
    }
    if (isConfirming.value) {
        emit("click");
        props?.forceOnClick?.value?.();
    }
    isConfirming.value = !isConfirming.value;
}

function cancel() {
    isConfirming.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["container", { confirming: isConfirming.value }])
  }, [
    (isConfirming.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.customDisplay ? __props.customDisplay : "Are you sure?"), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _withModifiers(click, ["stop"]),
      class: "button danger",
      disabled: __props.disabled
    }, [
      (isConfirming.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Yes"))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 8, _hoisted_2),
    (isConfirming.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "button",
          onClick: _withModifiers(cancel, ["stop"])
        }, "No", 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}
}

})